module.exports = {
  CUR_TIME   : "20251028_135350",
  VERSION    : "m-v0.85.19-138",
  GIT_HASH   : "8d0b8742e2",
  GIT_BRANCH : "HEAD",
  GIT_TAG    : "0.85.19",
  PKG_NAME   : "clearing_portal",
  APP_NAME   : "ClearingPortal"
}
